import template from './template.html'
import Controller from './controller'
import link from './composeBody.link'

export default ['$timeout', '$rootScope', directive]

function directive($timeout, root) {
  return {
    restrict: 'AE',
    template,
    link: link($timeout, root),
    controller: Controller,
  }
}
